<template>
    <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
    >
        <v-card tile>
            <v-toolbar flat dark color="primary">
                <v-btn
                    icon
                    dark
                    @click="closeMail"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ 'Create New Mail' }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                    dark
                    text
                    @click="clearForm"
                    >
                    Clear Form
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <ValidationObserver ref="observer">
                    <v-form ref="calform">
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <ValidationProvider v-slot="{ errors }" name="Email Title" rules="required">
                                    <v-text-field
                                    v-model="form.title"
                                    :error-messages="errors"
                                    label="Email Title"
                                    required
                                    ></v-text-field>
                                </ValidationProvider>
                                <ValidationProvider v-slot="{ errors }" name="Subject" rules="required">
                                    <v-text-field
                                    v-model="form.subject"
                                    :error-messages="errors"
                                    label="Subject"
                                    required
                                    ></v-text-field>
                                </ValidationProvider>
                                <tiptap-vuetify
                                    class="mt-4"
                                    v-model="form.content"
                                    :extensions="extensions"
                                    placeholder="Write your email here"
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-form>
                </ValidationObserver>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="primary" @click="submit" tile>Send Email</v-btn>
                <v-btn color="blue darken-1" text @click.prevent="closeMail">Close</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>      
        </v-card>
    </v-dialog>
</template>

<script>
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import { mapActions } from 'vuex'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['show', 'recepients'],
    data () {
        return {
            // declare extensions you want to use
            extensions: [
                History,
                Blockquote,
                Link,
                Underline,
                Strike,
                Italic,
                ListItem,
                BulletList,
                OrderedList,
                [Heading, {
                    options: {
                    levels: [1, 2, 3]
                    }
                }],
                Bold,
                Code,
                HorizontalRule,
                Paragraph,
                HardBreak
            ],
            // starting editor's content
            form: {
                title: '',
                subject: '',
                content: '',
                recepients: []
            },
            loading: false,            
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        TiptapVuetify
    },
    methods: {
        ...mapActions({
            newEmail: 'data/newEmail'
        }),
        async submit() {
            let valid = await this.$refs.observer.validate()

            if(valid) {
                this.loading = true
                this.$set(this.form, 'recepients', this.recepients)
                this.newEmail(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.closeMail()
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
            }
        },
        closeMail() {
            this.$emit('close-mail')
        },
        clearForm() {
            this.$refs.calform.reset()
            this.form.content = ''
        }
    }
}
</script>